import {useContext, useEffect, useState, useCallback, useRef} from 'react';
import {Button, Checkbox, Dialog, DialogActions, DialogContent, 
    DialogTitle, CircularProgress, Container, FormControlLabel, Grid, TextField,} from '@mui/material';
import {useParams, useHistory} from 'react-router-dom';
import {Controller, useForm} from 'react-hook-form';
import {IncoTermService} from '../../../services';
import ValidationError from "../../shared/ValidationError";
import {NotificationContext} from "../../../components/NotificationContext";
import Prompt from "../../../customUtil/Prompt";
import { CurrentUserContext } from '../../../components/CurrentUserContext';

const IncoTermForm = () => {
    const methods = useForm();
    const {handleSubmit, control, setValue, errors} = methods;

    const [data, setData] = useState({});
    const {showMessage, showError} = useContext(NotificationContext);
    const [isReady, setIsReady] = useState(false);
    const {id} = useParams();
    const history = useHistory();
    const [block, setBlock] = useState(false);  
    const refSubmitButtom = useRef();
    const [open, setOpen] = useState(false);
    const [openConfirmation, setOpenConfirmation] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const [triggerExit, setTriggerExit] = useState({
        onOk: false,
        path: ""
      });
    const [isVisibleDialog, setVisibleDialog] = useState(false);
    const {rights} = useContext(CurrentUserContext);
    const [showProgress, setShowProgress] = useState(false);
    const handleGoToIntendedPage = useCallback(
        (location) => history.push(location),
        [history]
      );
      
      const handleClose = () => {
        setOpen(false);
        setOpenConfirmation(false);
        setOpenInfo(false);
    }
    const removeIncoTerm = () => {
        setShowProgress(true);
        IncoTermService.delete(data.id).then((response) => {                
                showMessage('Successfully Deleted');
                history.push("/references/inco-terms");   
                setShowProgress(false);                                
            }).catch((response) => {
            handleClose();
            setOpenInfo(true);
            setShowProgress(false);                                

        });
    }

      useEffect(() => {
       
        const unblock = history.block((location) => {
          if (location.pathname !== `/gas/account-statements/${id}`) {
            if(block){
                setVisibleDialog(true);   
                setTriggerExit({...triggerExit, path: location.pathname});
            }else{
                setVisibleDialog(false);   
                setTriggerExit({onOk: true, path: location.pathname});
            }
                           
              }
         
          if (triggerExit.onOk) {
            return true;
          }
          return false;
        });
        if (triggerExit.onOk) {
            handleGoToIntendedPage(triggerExit.path);
          }
        return () => {
          unblock();
        };
      }, [history, triggerExit.onOk, triggerExit.path, block]);

    useEffect(() => {
        if (id !== "new") {
            IncoTermService.getById(id).then((response) => {
                setData(response.data);
                setIsReady(true);
            });
        } else {
            setData({});
            setIsReady(true);
        }
    }, [id, setValue]);


    const onSubmit = d => {
        setBlock(false);
        setVisibleDialog(false);
        if (data.id) {
            IncoTermService.update({...data, ...d})
                .then((response) => {
                    showMessage('Inco Term updated.')
                }).catch((response) => {
                    showError(response.message)
                });
        } else {
            IncoTermService.create({...data, ...d}).then((response) => {
                setData(response.data);
                showMessage('Inco Term Created.');
            });
        }
        setTimeout(() => {
            setIsReady(true);
            history.push('/references/inco-terms')
        }, 100) 
    };

    if (!isReady) {
        return (
            <CircularProgress/>
        );
    }
    const triggerSubmit = () => {
        refSubmitButtom?.current?.click();
      };     
   
      const onSave = (event) => {
          console.log(event)
          triggerSubmit();
          setBlock(false);
          setVisibleDialog(false);
      }
  
      const checkModified = (event) => {
          if(event.type ===  "change"){
              setBlock(true);
                 }
              }
    return (
        <Container>
            <header>
                <h1>Incoterm</h1>
            </header>
            <form style={{textAlign: 'left'}} onSubmit={handleSubmit(onSubmit)} onChange={event => {checkModified(event)}}>
            <Prompt
               visible={isVisibleDialog}
               onClose={() => setVisibleDialog(false)}
               onOk={() => {
               setTriggerExit({...triggerExit, onOk: true});
               setVisibleDialog(false);
               setBlock(false);
            }}
               onSave={onSave}
            />
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        Incoterms are internationally recognized rules which define the responsibilities of sellers and
                        buyers.
                    </Grid>

                    <Grid item xs={6}>
                        <Controller
                            name="termCode"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Code"
                            color="primary"
                            defaultValue={data.termCode}
                            rules={{required: 'Term code is required.'}}
                            variant="outlined"
                        />
                        <ValidationError error={errors.termCode}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <Controller
                            name="description"
                            control={control}
                            fullWidth
                            as={<TextField></TextField>}
                            label="Description"
                            color="primary"
                            variant="outlined"
                            rules={{required: 'Description is required.'}}
                            defaultValue={data.description}
                        />
                        <ValidationError error={errors.description}/>
                    </Grid>

                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <br/>
                        <FormControlLabel label="For Client" variant="outlined" control={
                            <Controller
                                name="forClient"
                                control={control}
                                color="primary"
                                variant="outlined"
                                defaultValue={data.forClient}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>

                    </Grid>
                    <Grid item xs={6}>
                    </Grid>
                    <Grid item xs={6}>
                        <FormControlLabel label="For Vendors" variant="outlined" control={
                            <Controller
                                name="forVendor"
                                control={control}
                                fullWidth
                                label="For Vendor"
                                color="primary"
                                variant="outlined"
                                defaultValue={data.forVendor}
                                render={(
                                    {onChange, onBlur, value, name, ref},
                                    {invalid, isTouched, isDirty}
                                ) => (
                                    <Checkbox
                                        onBlur={onBlur}
                                        onChange={(e) => onChange(e.target.checked)}
                                        checked={value}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        }/>
                    </Grid>
                    <Grid item xs={10}>
                            <Button variant="contained" color="primary" type="submit">Submit</Button>
                        </Grid>
                        {(rights.includes("ROLE_SI_ADMIN") && id !== 'new') &&                        
                        <Grid item xs={2}>
                            <Button variant="contained" color="danger" onClick={() => setOpenConfirmation(true)}>Remove Inco Term</Button>
                        </Grid>
                      }
                </Grid>
                <button hidden={true} ref={refSubmitButtom} type={"submit"} />
            </form>
            <Dialog open={openConfirmation} onClose={handleClose} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Confirm Delete</DialogTitle>
                    <DialogContent>                      
                          Are you sure you want to delete this Inco Term?                                           
                    </DialogContent>
                    <DialogActions>
                        {showProgress &&  <CircularProgress style={{width: "12px", height: "10px"}}/>}                       
                    <Button onClick={removeIncoTerm} color="primary" disabled={showProgress}>
                            yes
                        </Button>
                        <Button onClick={handleClose} color="primary">
                            No
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog open={openInfo} onClose={handleClose} aria-labelledby="form-dialog-title">                   
                    <DialogContent>                       
                          This Inco Term can not be deleted because it is already in use.                                             
                    </DialogContent>
                    <DialogActions>                    
                        <Button onClick={handleClose} color="primary">
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>
        </Container>
    );
};

export default IncoTermForm;
